import Swal from "sweetalert2"

export const SuccessAlert = async ({ message }: { message: string }) => {

  return await Swal.fire({
    title: "Sucesso",
    text: message,
    icon: "success",
    showConfirmButton: true,
  })
}
